import { makeStyles, createStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  () =>
    createStyles({
      container: {
        padding: '4px 0',
      },
      subTitle: {
        fontSize: '16px',
        fontFamily: 'Nunito',
        paddingBottom: '12px',
        paddingTop: '12px',
      },
      itemEleicao: {
        backgroundColor: '#F8F9F7',
        height: '56px',
        padding: '10px',
        marginBottom: '8px',
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
      },
      itemText: {
        fontSize: '16px',
        fontFamily: 'Nunito',
        padding: '10px 0',
      },
    }),
  {
    name: 'PautaEleicaoModal',
  }
);
